<template>
  <div>
    <van-popup v-model="isactive" position="bottom">
      <van-picker
        show-toolbar
        title="年代"
        :columns="columns"
        @cancel="isactive=false"
        @confirm="onConfirm"
      />
    </van-popup>

    <van-row :gutter="15">
      <van-col :span="24">
        <div
          :class="{'form-box-tag':true,'active':currentIndex ? true:false}"
          @click="isactive=true"
        >{{searchValue}}</div>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import {
  Button,
  Icon,
  Row,
  Col,
  Tag,
  IndexBar,
  IndexAnchor,
  Cell,
  CellGroup,
  Popup,
  Picker
} from "vant";

export default {
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [Row.name]: Row,
    [Col.name]: Col,
    [Tag.name]: Tag,
    [IndexBar.name]: IndexBar,
    [IndexAnchor.name]: IndexAnchor,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Popup.name]: Popup,
    [Picker.name]: Picker
  },

  data() {
    return {
      isactive: false,
      currentIndex: false,
      searchValue: "选择年代",
      indexlist: [],
      columns: []
    };
  },
  props: {
    lists: Array
  },

  mounted() {},
  watch: {
    lists: function() {
      this.columns = this.lists;
    }
  },
  methods: {
    onConfirm(value, index) {
      this.isactive = false;
      this.searchValue = value;
      this.currentIndex = true;
      this.$emit("change", value);
    }
  }
};
</script>

<style scoped>
.popo {
  position: absolute;
  z-index: 3000;
  background-color: #fff;
  top: 0;
  width: 100vw;
}
.form-box-tag {
  background-color: #f8f8f8;
  line-height: 32px;
  text-align: center;
  color: #555;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 10px;
}
.form-box-tag.active {
  background-color: #feefe9;

  color: #f56229;
}
.popupclose {
  position: fixed;
  text-align: center;
  bottom: 20px;
  width: 100%;
}
</style>>



